"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyCellRenderer = void 0;
const components_1 = require("@veeam/components");
const trimmedTextRenderer_1 = require("@veeam/components/lib/Grid/cellRenderers/trimmedTextRenderer");
require("../../../core");
const helpers_1 = require("../../../helpers");
require("./types");
const currencyCellRenderer = ({ fixedDigits, prefix = '$', suffix = '', } = {}) => (_a) => {
    var { cellData } = _a, otherProps = __rest(_a, ["cellData"]);
    const value = helpers_1.formatNumber(cellData, { fixedDigits });
    return trimmedTextRenderer_1.trimmedTextRenderer(Object.assign(Object.assign({}, otherProps), { headerJustify: components_1.GRID_COLUMN_HEADER_JUSTIFY.right, cellData: `${prefix}${value}${suffix}` }));
};
exports.currencyCellRenderer = currencyCellRenderer;
//# sourceMappingURL=currencyCellRenderer.js.map